export default __webpack_public_path__ + "howitworks-epl-mobile-88cd121abcb769b09940aed3efc0bc58.jpg";